export default function BalanceOf()
{
    return(<>
        <div class="form-example">
            <h2>会津無尽にある皆んなのAMT</h2>
            <span class="dispBalance" id ="AizuMujinTotalToken"></span>
            <br />
            <h2>自分の保有AMT</h2>
            <span class="dispBalance"  id ="myTotalToken"></span>
        </div>
    </>);
}
